import { log } from '@/log'
import { ApiClient } from '@/services/api/client'
import { callWithAuth } from '@/services/auth/call-with-auth'
import { Either, left, right } from 'fp-ts/lib/Either'
import { ApiService } from '../api/service'

export class SmsAuthService extends ApiService {
  constructor (
    private readonly apiClient: typeof ApiClient = ApiClient
  ) {
    super()
  }

  async sendAuthToken(): Promise<Either<Error, null>> {
    const target = `/api/user-proxy/${this.appId}/auth_confirm_sms`
    try {
      const response = await callWithAuth(() => this.apiClient.post(target))

      log.debug({ service: target, response })

      return right(null)
    } catch (error) {
      log.error({ service: target, error })

      return left(error)
    }
  }

  async authenticate(token: string): Promise<Either<Error, null>> {
    const target = `/api/user-proxy/${this.appId}/auth_confirm_complete`
    try {
      const response = await callWithAuth(() => this.apiClient.post(target, { token }))

      log.debug({ service: target, response })

      return right(null)
    } catch (error) {
      log.error({ service: target, error })

      return left(error)
    }
  }
}
